import stickyDrawer from './sticky-drawer';

export default function () {

  $.when(
    $.ajax('../share/isi/sticky-top.html'),
    $.ajax('../share/isi/box-warning.html'),
    $.ajax('../share/isi/indication-usage.html'),
    $.ajax('../share/isi/other.html')
  ).done(function(stickyTop, boxWarning, indicationUsage, otherIsi){

    $(window).on('resize', function() {
      $('.isi-text.drawer').empty();
      $('.isi-text.full').empty();

      if ($(window).width() < 768) {
        $('.isi-text.drawer').append(stickyTop[0]).append(indicationUsage[0]).append(boxWarning[0]).append(otherIsi[0]);
        $('.isi-text.full').append(indicationUsage[0]).append(boxWarning[0]).append(otherIsi[0]);
      } else {
        $('.isi-text.drawer').append(stickyTop[0]).append(indicationUsage[0]).append(boxWarning[0]).append(otherIsi[0]);
        $('.isi-text.full').append(indicationUsage[0]).append(boxWarning[0]).append(otherIsi[0]);
      }
    }).resize();

    stickyDrawer();
  }).fail(function(error){
    console.error('Error loading ISI text:', error.statusText);
  });
  
  $(function(){
    if ($('#indication-usage').length) {
      $('#indication-usage').load('../share/isi/indication-usage.html'); 
    }
  });

}



// WEBPACK FOOTER //
// ./js/modules/isi.js